import axios from 'axios';

// Public share endpoints are unauthenticated. We deliberately use a fresh
// axios instance (not `httpClient`) so no Authorization header or 401-redirect
// interceptor is attached.
const publicApi = axios.create({
  baseURL: '/api/v1/public',
  headers: {
    Accept: 'application/json',
  },
});

/**
 * Fetch share metadata (label, expiresAt). Throws on network/non-410 errors.
 * For 410 Gone (revoked/expired/exhausted) the rejection's `error.response`
 * is preserved so callers can detect the unavailable state.
 */
export const fetchPublicShareMeta = async (token) => {
  const response = await publicApi.get(`/shares/${encodeURIComponent(token)}`);
  return response.data;
};

/**
 * Fetch the full SharedDetectionDto for the share. Same 410 contract applies.
 */
export const fetchPublicShareDetection = async (token) => {
  const response = await publicApi.get(`/shares/${encodeURIComponent(token)}/detection`);
  return response.data;
};

/**
 * Build a direct image URL suitable for use as `<img src>`.
 * Type is one of: `annotated`, `full`, `thumbnail`.
 */
export const buildShareImageUrl = (token, type) =>
  `/api/v1/public/shares/${encodeURIComponent(token)}/image?type=${encodeURIComponent(type)}`;

const publicShareService = {
  fetchPublicShareMeta,
  fetchPublicShareDetection,
  buildShareImageUrl,
};

export default publicShareService;
